import * as React from 'react';
const SvgPostmark = (props) => (
  <svg viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M34.354 68.707c18.973 0 34.353-15.38 34.353-34.353S53.327 0 34.354 0 0 15.38 0 34.354c0 18.973 15.38 34.353 34.354 34.353Z"
      fill="#FFDE00"
    />
    <path
      d="M23.773 47.303h1.812c.931 0 1.519-.6 1.519-1.552v-21.22c0-.95-.588-1.55-1.519-1.55h-1.812v-4.705h13.128c7.053 0 12.637 3.654 12.637 10.61 0 7.006-5.584 10.66-12.637 10.66h-4.507v6.205c0 .951.588 1.552 1.568 1.552h3.673v4.754H23.773v-4.754ZM36.509 34.64c4.653 0 7.347-2.002 7.347-5.655 0-3.753-2.694-5.655-7.347-5.655h-4.115v11.36h4.115v-.05Z"
      fill="#000"
    />
  </svg>
);
export default SvgPostmark;
